module.exports = __webpack_public_path__ + "public/Icons/pauseAudio.svg?0fb67148";